import { render, staticRenderFns } from "./AllTransactionCodes.vue?vue&type=template&id=4b54ab98&"
import script from "./AllTransactionCodes.vue?vue&type=script&lang=js&"
export * from "./AllTransactionCodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports